<div class="entities-info" *ngIf="entities.length > 0">
  <h1 [style.color]="label.main_color">{{label.display_name | titlecase}}</h1>
  <div class="chips-holder">
    <div *ngFor="let entity of entities" class="side-chip">
      <span>{{ entity.label }}</span>  <img src="./assets/ui/svg/white/close.svg" (click)="delete(entity)"/>
    </div>
  </div>
</div>
